const YoutubeEmbed = () => (
  <>
    <video autoPlay loop muted playsInline title="Embedded cloudinary video">
      <source
        src="https://res.cloudinary.com/isaacdev/video/upload/v1715140806/intro_nubfsz.mp4"
        type="video/mp4"
      />
    </video>
  </>
);

export default YoutubeEmbed;
